import { render, staticRenderFns } from "./TodosFooter.vue?vue&type=template&id=3b27a4d9&"
import script from "./TodosFooter.vue?vue&type=script&lang=js&"
export * from "./TodosFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports